import confetti from 'canvas-confetti';
const colors = ["#f7ea5c", "#05f5dd", "#30fc03", "#ff0011", "#ff9d00"];
const duration = Date.now() + 1000;

export const schoolPride = () => {

    confetti({
        particleCount: 100,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors
    });
    confetti({
        particleCount: 100,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
    });

    if (Date.now() < duration) {
        requestAnimationFrame(schoolPride);
    }
}

export const firework = () => {
    var duration = 2000; // 2 * 1000
    var animationEnd = Date.now() + duration;
    var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 999999 };

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    var interval = setInterval(function () {
        var timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            return clearInterval(interval);
        }
        var particleCount = 100 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }, colors: colors });
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }, colors: colors });
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.3, 0.7), y: Math.random() - 0.2 }, colors: colors });
    }, 500);
}
// Notwork: Find other solution
export const stopConfetti = () => confetti.reset();